/**
 	* Food Calculator
	* @module food-calculator
	* @version 1.0.0
	* @extends HTMLElement
**/

customElements.component = 'food-calculator';

if (!customElements.get(customElements.component)) {
	class foodCalculator extends HTMLElement {
		constructor() {
			super();

			this.dogsData = this.dogsData || [];
			this.enabled = this.dataset.enabled === 'true';
			this.location = this.dataset.location;
			this.calculatorTrigger = this.querySelector('.calculator-trigger');
			this.addButton = this.querySelector('.add');
			this.calculateButton = this.querySelector('.calculate');
			this.okButton = this.querySelector('.ok');
			this.resetButton = this.querySelector('.reset');
			this.allDogs = this.querySelector('.all-dogs');
			this.resultsContainer = this.querySelector('.results');
			this.resultsPerDogContainer = this.querySelector('.results-per-dog');
			this.numberOfDaysContainer = this.querySelector('.number-of-days');
			this.numberOfDaysInput = this.querySelector('input#numberOfDays');
			this.dogFoodForm = this.querySelector('#dog-food-calculator');
			this.innerCalculator = document.querySelector('.inner-calculator');
			this.totalBagsElement = this.querySelector('.total-bags');
			this.totalBagsAmount = this.querySelector('.total-bags .amount');

			this.totalPoundsPerDay = 0;
			this.gramsInPound = 453.592;
			this.ouncesInPound = 16;

			if (this.location === 'product') {
				this.productData = JSON.parse(this.querySelector('script[type="application/json"]').innerHTML);
			}

			this.productWeight = Math.floor(this.extractShippingWeight(this.productData) / this.gramsInPound);

			this.dogCounter = 1;
			this.dogInputFieldsTemplate = `
				<div id="dog-{{ dog_index }}" class="dog" data-dog-index="{{ dog_index }}">
					<div class="remove" data-dog-id="dog-{{ dog_index }}">remove</div>
					
					<div class="form-row">
						<div class="form-column">
							<label for="dogName-{{ dog_index }}">Dog's Name:</label>
							<input type="text" id="dogName-{{ dog_index }}" name="dogName-{{ dog_index }}" required>
							<div id="error-dogName-{{ dog_index }}" class="error"></div>
						</div>
					
						<div class="form-column">
							<label for="age-{{ dog_index }}">Dog's Age</label>
							<input
							type="number"
							id="age-{{ dog_index }}"
							name="age-{{ dog_index }}"
							min="0"
							step="any"
							required
							>
							<div id="error-age-{{ dog_index }}" class="error"></div>
						</div>
					</div>

					<div class="form-row">
						<div class="form-column">
							<div class="cell">
								<label for="currentWeight-{{ dog_index }}">Current Weight (lbs)</label>
								<input
								type="number"
								id="currentWeight-{{ dog_index }}"
								name="currentWeight-{{ dog_index }}"
								min="0"
								step="any"
								required
								>
								<div id="error-currentWeight-{{ dog_index }}" class="error"></div>
							</div>

							<div class="cell">
								<label for="targetWeight-{{ dog_index }}">Target Weight (lbs):</label>
								<input
								type="number"
								id="targetWeight-{{ dog_index }}"
								name="targetWeight-{{ dog_index }}"
								min="0"
								step="any"
								required
								>
								<div id="error-targetWeight-{{ dog_index }}" class="error"></div>
							</div>
						</div>

						<div class="form-column">
							<div class="kibble-question-label">
								<span>Are you mixing with Kibble?</span>
								<i class="fa-regular fa-info-circle kibble-question"></i>
							</div>
						
							<label for="dogKibble-{{ dog_index }}">
								<input type="checkbox" id="dogKibble-{{ dog_index }}" name="dogKibble-{{ dog_index }}" class="dogKibble">
								<span>Yes, I am mixing with kibble</span>
							</label>
						
							<div id="error-dogKibble-1" class="error"></div>
						</div>
					</div>
				</div>
			`;
			this.dogResultsTemplate = `
				<div id="dog-result-{{ dog_index }}" class="dog-result" data-dog-index="{{ dog_index }}">
					<h4>{{ dog_name }}'s feeding portion</h4>
					<p class="food-per-feeding">
						<span class="value-label">Food per feeding:</span>
						<span class="value">{{ food_per_feeding }} oz</span>
					</p>
					<p class="recommended-feedings">Two feedings recommended per day.</p>
				</div>
			`

			this.initEvents();
		}

		initEvents() {
			if (!this.enabled) return;

			if (this.dogFoodForm) {
				this.dogFoodForm.addEventListener('input', () => {
					this.validateFormAndToggleCalculateButton();
				});
			}

			this.addEventListener('click', (event) => {
				const addButton = event.target.closest('.add');
				const removeButton = event.target.closest('.remove');
				const calculateButton = event.target.closest('.calculate');
				const resetButton = event.target.closest('.reset');
				const okButton = event.target.closest('.ok');
				const calculatorTrigger = event.target.closest('.calculator-trigger');

				// add button logic
				if (addButton) {
					this.addDog();
                  this.validateFormAndToggleCalculateButton();
				}

				// remove button logic
				if (removeButton) {
					this.removeDog(removeButton);
                  this.validateFormAndToggleCalculateButton();
				}

				// calculate button logic
				if (calculateButton) {
					this.calculateFood();
				}

				// reset button logic
				if (resetButton) {
					this.resetForm();
				}

				// confirm button logic
				if (okButton) {
					this.ok();
				}

				// calculator trigger button logic
				if (calculatorTrigger) {
					calculatorTrigger.classList.toggle('active');

					if (this.innerCalculator) {
						this.innerCalculator.style.display = this.innerCalculator.style.display === 'block' ? 'none' : 'block';
					}
				}
			});

			if (this.numberOfDaysInput) {
				this.numberOfDaysInput.addEventListener('input', (event) => {
					let numDays = parseInt(this.numberOfDaysInput.value); // Get the number of days entered

					if (!isNaN(numDays) && numDays > 0) {
						// Calculate total cost for the entered number of days
						let totalPounds = this.totalPoundsPerDay * numDays;

						// Calculate quantity based on total cost and price per unit
						let quantity = totalPounds / this.productWeight;

						// Round quantity to the next whole number
						this.totalBags = Math.ceil(quantity);
						if (this.totalBagsAmount) {
							this.totalBagsAmount.innerHTML = `${this.totalBags}`;
						}

						this.totalBagsElement.style.display = this.totalBagsElement.style.display !== 'block' ? 'block' : this.totalBagsElement.style.display;
						const qtyInput = document.querySelector('.product-form__quantity input[name="quantity"]');

						if (qtyInput) {
							qtyInput.value = this.totalBags;
						}
					}
                   this.validateFormAndToggleCalculateButton();
				});
			}

			this.setKibbleQuestions();
		}

		extractShippingWeight(productData) {
			if (!productData) return 1;
			if (!this.productData.variants[0].weight) return 1;

			return parseFloat(this.productData.variants[0].weight);
		}

		calculateQuantity(totalPoundsNeeded) {
			// If a dog needs 2 lbs per day for 5 days (10 lbs total)
			// and they're buying a 5 lb sampler, they need quantity of 2
			return Math.ceil(totalPoundsNeeded / this.productWeight);
		}

		updateResults(totalPoundsNeeded) {
			const quantity = this.calculateQuantity(totalPoundsNeeded);
			// Update UI elements to show:
			// - Total pounds of food needed
			// - Product weight
			// - Quantity to add to cart
			this.totalBagsAmount.textContent = quantity;
			// Also add clarity about how many days this will feed the dog(s)
			console.log('quantity:', quantity)
		}

		addDog() {
			if (this.dogCounter === 0) {this.dogCounter = 1}
			this.dogCounter++;

			let newDog = this.dogInputFieldsTemplate.replace(/{{ dog_index }}/g, this.dogCounter);
			this.allDogs.insertAdjacentHTML('beforeend', newDog);

			this.setKibbleQuestions();
          this.validateFormAndToggleCalculateButton();
		}

		removeDog(removeButton) {
			if (!removeButton) return;

			const dogId = removeButton.getAttribute('data-dog-id');
			const dogElement = this.querySelector(`#${dogId}`);

			if (dogElement) {
				// Remove the dog element
				dogElement.remove();

				// Update the IDs of remaining dogs
				const remainingDogs = this.allDogs.querySelectorAll('.dog');
				remainingDogs.forEach((dog, index) => {
					const newIndex = index + 1;
					const oldId = dog.id;
					const dogNumber = oldId.split('-')[1];

					// Update the main container ID
					dog.id = `dog-${newIndex}`;

					// Update the remove button data attribute
					const removeBtn = dog.querySelector('.remove');
					if (removeBtn) {
						removeBtn.setAttribute('data-dog-id', `dog-${newIndex}`);
					}

					// Update all labels and inputs IDs/names/for attributes
					const labels = dog.querySelectorAll('label');
					const inputs = dog.querySelectorAll('input');
					const errors = dog.querySelectorAll('.error');

					labels.forEach(label => {
						const forAttr = label.getAttribute('for');
						if (forAttr && forAttr.includes(dogNumber)) {
							label.setAttribute('for', forAttr.replace(dogNumber, newIndex));
						}
					});

					inputs.forEach(input => {
						const inputId = input.getAttribute('id');
						const inputName = input.getAttribute('name');
						if (inputId && inputId.includes(dogNumber)) {
							input.setAttribute('id', inputId.replace(dogNumber, newIndex));
						}
						if (inputName && inputName.includes(dogNumber)) {
							input.setAttribute('name', inputName.replace(dogNumber, newIndex));
						}
					});

					errors.forEach(error => {
						const errorId = error.getAttribute('id');
						if (errorId && errorId.includes(dogNumber)) {
							error.setAttribute('id', errorId.replace(dogNumber, newIndex));
						}
					});
				});

				// Update dog counter based on number of dogs
				this.dogCounter = remainingDogs.length;
				this.setKibbleQuestions();
                this.validateFormAndToggleCalculateButton();
			}
		}

		setKibbleQuestions() {
			const kibbleQuestions = this.allDogs.querySelectorAll('.kibble-question');
			if (!kibbleQuestions.length) return;

			kibbleQuestions.forEach(kibbleQuestion => {
				if (typeof tippy !== 'function') return;

				tippy(kibbleQuestion, {
					content: `
						<div class="kibble-question-tooltip">
							If you select "yes" for this question, the portion result will be reduced by half.                    </div>
						</div>
					`,
					allowHTML: true,
					trigger: 'mouseenter click',
					hideOnClick: 'toggle'
				});
			});
		}

		validateFormAndToggleCalculateButton() {
			// Default to enabled
			let enableCalculateButton = true;

			// Get all dogs in the form
			const dogs = this.allDogs.querySelectorAll('.dog');
			const isSingleDog = dogs.length === 1;

			if (isSingleDog) {
				const singleDog = dogs[0];
				const singleRequiredInputs = singleDog.querySelectorAll('input[required]');

				let hasFilledInput = false;
				let allInputsFilled = true;

				singleRequiredInputs.forEach(input => {
					if (input.value.trim() !== '') {
						hasFilledInput = true;
					}

					if (input.value.trim() === '') {
						allInputsFilled = false;
					}
				});

				if (hasFilledInput && !allInputsFilled) {
					enableCalculateButton = false;
				}
			} else {
				// Check if any dog has been started but not completed
				dogs.forEach(dog => {
					// Get all required inputs in this dog form
					const requiredInputs = dog.querySelectorAll('input[required]');

					// Check if any required input has been filled
					let hasFilledInput = false;
					let allInputsFilled = true;

					requiredInputs.forEach(input => {
						if (input.value.trim() !== '') {
							hasFilledInput = true;
						}

						if (input.value.trim() === '') {
							allInputsFilled = false;
						}
					});

					// If some inputs are filled but not all, disable the button
					if (hasFilledInput && !allInputsFilled) {
						enableCalculateButton = false;
					}
				});
			}

			// Update calculate button state
			if (enableCalculateButton) {
				this.calculateButton.removeAttribute('disabled');
				this.calculateButton.classList.remove('disabled');

				this.resetButton.removeAttribute('disabled');
				this.resetButton.classList.remove('disabled');
			} else {
				this.calculateButton.setAttribute('disabled', 'disabled');
				this.calculateButton.classList.add('disabled');

				this.resetButton.setAttribute('disabled', 'disabled');
				this.resetButton.classList.add('disabled');
			}
		}

		resetForm() {
			// remove all dogs except for one
			let dogs = this.allDogs.querySelectorAll('.dog');
			if (dogs.length > 1) {
				dogs.forEach(dog => {
					if (dog.id !== 'dog-1') dog.remove();
				});

				this.dogCounter = 1;
			}

			// clear remaining inputs
			let inputs = this.querySelectorAll('input');
			if (!inputs.length) return;

			inputs.forEach((input) => {
				input.value = '';
				input.disabled = false;
			});

			// clear error messages
			this.errorMessages = this.querySelectorAll('.error');
			if (this.errorMessages.length) {
				this.errorMessages.forEach(el => el.textContent = '');
			}

			// clear results
			if (this.resultsContainer && this.resultsPerDogContainer) {
				this.resultsContainer.style.display = 'none';
				this.resultsPerDogContainer.innerHTML = '';
			}

			// hide number of days input
			this.numberOfDaysContainer.style.display = 'none';

			// enable add button
			this.addButton.removeAttribute('disabled');
			this.addButton.classList.remove('disabled');

			// enable number of days input
			this.numberOfDaysInput.removeAttribute('disabled');
			this.numberOfDaysInput.classList.remove('disabled');
			this.numberOfDaysContainer.style.display = 'none';

			// disabled confirm button
			this.okButton.setAttribute('disabled', 'disabled');
			this.okButton.classList.add('disabled');
			this.okButton.style.display = 'none';

			// disable calculate button
			this.calculateButton.setAttribute('disabled', 'disabled');
			this.calculateButton.classList.add('disabled');
			this.calculateButton.style.display = 'block';

			// disable reset button
			this.resetButton.setAttribute('disabled', 'disabled');
			this.resetButton.classList.add('disabled');

			// clear dog data
			this.dogsData = [];
			this.pricePerDay = 0;
			this.totalBagsElement.style.display = 'none';
			this.totalBagsAmount.innerHTML = '';

			this.setKibbleQuestions();
		}

		calculateFood() {
			this.resultsPerDogContainer.innerHTML = '';

			const dogs = this.allDogs.querySelectorAll('.dog');
			dogs.forEach(dog => {
				const dogName = dog.querySelector('input[name*="dogName"]').value;
				const age = dog.querySelector('input[name*="age"]').value;
				const currentWeight = dog.querySelector('input[name*="currentWeight"]').value;
				const targetWeight = dog.querySelector('input[name*="targetWeight"]').value;
				const dogKibble = dog.querySelector('input[name*="dogKibble"]').checked;

				const formValues = {
					dogName,
					age,
					currentWeight,
					targetWeight,
					dogKibble,
					dogIndex: dog.getAttribute('data-dog-index')
				};

				this.calculate(formValues);
			});

			const currentRemoveButtons = this.allDogs.querySelectorAll('.remove');
			if (currentRemoveButtons.length) {
				currentRemoveButtons.forEach(removeButton => {
					removeButton.remove();
				});
			}

			const currentInputs = this.allDogs.querySelectorAll('input');
			if (currentInputs.length) {
				currentInputs.forEach(input => {
					input.disabled = true;
				});
			}

			this.addButton.setAttribute('disabled', 'disabled');
			this.addButton.classList.add('disabled');

			this.numberOfDaysContainer.style.display = 'block';
			if (this.location === 'product') {
				this.okButton.style.display = 'block';
				this.okButton.removeAttribute('disabled');
				this.okButton.classList.remove('disabled');
			}
			this.calculateButton.style.display = 'none';
		}

		calculate(formValues) {
			if (!formValues) return this.resetForm();

			const multiplier = this.calculatePercentage(formValues.currentWeight, formValues.targetWeight, formValues.age) / 100;
			let foodPerFeedingGrams = Math.ceil(((formValues.targetWeight * multiplier) / 2) * 500 / 10) * 10;
			let foodPerFeedingPounds = foodPerFeedingGrams / this.gramsInPound;
			let foodPerDayPounds = foodPerFeedingPounds * 2;

			// Convert to ounces
			let foodPerFeedingOunces = foodPerFeedingGrams / (this.gramsInPound / this.ouncesInPound);
			let foodPerDayOunces = foodPerFeedingOunces * 2; // Multiply by 2 for daily amount

			if (formValues.dogKibble) {
				foodPerFeedingOunces = foodPerFeedingOunces / 2;
			}

			this.dogsData.push({
				dogName: formValues.dogName,
				foodPerFeeding: foodPerFeedingOunces,
				dogIndex: formValues.dogIndex
			});

			this.totalPoundsPerDay = this.totalPoundsPerDay + foodPerDayPounds;

			console.log('foodPerFeedingGrams:', foodPerFeedingGrams);
			console.log('foodPerFeedingPounds:', foodPerFeedingPounds);
			console.log('foodPerDayPounds:', foodPerDayPounds);
			console.log('foodPerFeedingOunces:', foodPerFeedingOunces);
			console.log('foodPerDayOunces:', foodPerDayOunces);

			console.log('kibble would divide values by 2');

			//this.updateResults(foodPerDayPounds);

			let newDogResult = this.dogResultsTemplate.replace(/{{ dog_index }}/g, formValues.dogIndex);
			newDogResult = newDogResult.replace(/{{ dog_name }}/g, formValues.dogName);
			newDogResult = newDogResult.replace(/{{ food_per_feeding }}/g, foodPerFeedingOunces.toFixed(2));

			this.resultsPerDogContainer.insertAdjacentHTML('beforeend', newDogResult);
			this.resultsContainer.style.display = 'block';
		}

		calculatePercentage(currentWeight, targetWeight, age) {
			// Input validation
			if (targetWeight === "" || age === "") return "";

			// Convert to numbers if they're strings
			currentWeight = Number(currentWeight);
			targetWeight = Number(targetWeight);
			age = Number(age);

			// Need to lose weight
			if (currentWeight > targetWeight) {
				return 2;
			}

			// Puppy (under 2 years) - assumes gaining weight
			if (age < 2) {
				return 3;
			}

			// Senior dog (over 8 years) - assume less active
			if (age > 8) {
				return 2.25;
			}

			// Adult dog between 2-8 years
			if (age >= 2 && age <= 8) {
				// Needs to gain weight
				if (currentWeight < targetWeight) {
					return 2.75;
				} else {
					// Maintaining weight (current = target)
					return 2.25;
				}
			}

			// Default case (shouldn't reach here with proper inputs)
			return 2.5;
		}

		ok() {
			if (this.numberOfDaysInput.value === '' || this.numberOfDaysInput.value === '0') return;

			document.querySelector('.product-form__quantity input[name="quantity"]').value = this.totalBags;

			this.numberOfDaysInput.setAttribute('disabled', 'disabled');
			this.numberOfDaysInput.classList.add('disabled');

			if (this.calculatorTrigger) {
				this.calculatorTrigger.classList.remove('active');
			}

			if (this.innerCalculator) {
				this.innerCalculator.style.display = 'none';
			}

           // Scroll to the top of the page
              window.scrollTo({
                  top: 0,
                  behavior: 'smooth' // Smooth scroll
            });

			//this.resetForm();
		}
	}

	customElements.define(customElements.component, foodCalculator);
}
